import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { API } from "@/lib/api";

export default function AgeGate({ onAccept }) {
  const [proof, setProof] = useState({ tip: null });

  useEffect(() => {
    let mounted = true;
    fetch(`${API}/tips/yesterday`)
      .then((r) => r.json())
      .catch(() => ({}))
      .then((y) => {
        if (!mounted) return;
        setProof({ tip: y?.tip || null });
      });
    return () => {
      mounted = false;
    };
  }, []);

  const wonYesterday = proof.tip && proof.tip.result === "won";

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black py-10"
      data-testid="age-gate"
    >
      <div className="w-full max-w-sm px-8 text-center">
        <div className="mb-2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">
          DailyRacer
        </div>

        {/* Social proof strip */}
        {wonYesterday && (
          <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="mb-6 space-y-2"
            data-testid="landing-social-proof"
          >
            <div className="flex items-center justify-center gap-2 rounded-full border border-[#4ADE80]/40 bg-[#4ADE80]/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#4ADE80]">
              <Trophy size={12} />
              <span>
                Yesterday: {proof.tip.selection} · {proof.tip.odds}
              </span>
            </div>
          </motion.div>
        )}

        <h1 className="font-display text-5xl leading-none text-white">
          One tip.<br />
          <span className="text-[#E1FF00]">£2 to unlock.</span>
        </h1>
        <p className="mt-5 text-sm leading-relaxed text-zinc-400">
          UK racing, one high-conviction pick a day. No sign-up, no subs — pay when you like it.
        </p>

        <div className="mt-8 rounded-2xl border border-zinc-900 bg-zinc-950/80 p-4">
          <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
            Are you 18+?
          </div>
          <div className="mt-4 flex flex-col gap-3">
            <button
              data-testid="age-gate-yes"
              onClick={onAccept}
              className="dr-btn-primary rounded-full px-6 py-4 text-base"
            >
              Yes, I'm over 18 — show me today's tip
            </button>
            <a
              data-testid="age-gate-no"
              href="https://www.begambleaware.org"
              className="rounded-full border border-zinc-800 px-6 py-3 text-sm text-zinc-400 hover:bg-zinc-900"
            >
              No, take me away
            </a>
          </div>
        </div>

        <p className="mt-6 text-[10px] uppercase tracking-[0.2em] text-zinc-600">
          GamCare · BeGambleAware · 18+
        </p>
      </div>
    </motion.div>
  );
}
